import type { ComponentProps } from "react";
import { Toaster as Sonner } from "sonner";

import { cn } from "@/shadcn/lib/utils";

import { baseToastOptions, mergeToastOptions, toastIcons } from "./toast";

type ToasterProps = ComponentProps<typeof Sonner>;

const BASE_TOASTER_CLASS = "toaster group";

export default function Toaster({ className, toastOptions, icons, ...props }: ToasterProps) {
  return (
    <Sonner
      className={cn(BASE_TOASTER_CLASS, className)}
      icons={{ ...toastIcons, ...icons }}
      toastOptions={mergeToastOptions(baseToastOptions, toastOptions)}
      {...props}
    />
  );
}
